import React from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment/moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { submitDnataExtraForm } from "../../redux/actions/index";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";

const NoticeForm = ({
  appData: { dnataOnboarding, firstName, lastName },
  submitForm,
}) => {
  const typeCode = "YDN9";
  const fullName = `${firstName} ${lastName}`;
  const submitted = dnataOnboarding && dnataOnboarding[typeCode];

  const initialData = {
    name: fullName,
    signature: fullName,
  };
  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: (
        <div>
          <p className="font-weight-bold">
            This notice is issued to all staff and management following a number
            of recent incidents involving the removal and taking of stock items
            without the necessary permission or authority and reiterates and
            confirms the company’s rules and procedures.
          </p>
          <p>
            This notice supersedes any previously issued advisement and any
            ‘custom or practices’, which may have been adopted. All items of
            stock and equipment remain the sole property of the company (dnata
            catering UK Ltd) or its customers for whom it acts as custodian of
            any stock and Equipment.
          </p>
          <p>
            Under no circumstances is any member of staff or management (Full
            time, Part time or agency) permitted or authorised to take or remove
            any item(s) of stock or equipment for their consumption and use, or
            for the consumption and use by any third party, unless specifically
            authorised in writing prior to the removal of the item(s) by the
            unit manager only.{" "}
            <strong>
              Items of stock, which have been designated as waste, damaged or
              ullaged, remain the property of the company or its customers and
              are covered by this ruling.
            </strong>
          </p>
          <div className="font-weight-bold">
            <p>
              In addition to the above, it is imperative that under no
              circumstances is any staff member or manager to receive or take
              from any other person, known or unknown, any package/s, gift or
              reward for which no previous permission has been obtained.
            </p>
            <p>
              Where an external staff search has commenced outside of the dnata
              catering UK Ltd premises under no circumstances may an employee
              return to the building without authorisation from the searcher
              until the search has been completed.
            </p>
          </div>
          <p>
            The above instruction’s covers all operational areas of the company
            and is inclusive of all airside locations, aircraft, bonded
            warehouses, other dnata catering UK Ltd properties and all company
            vehicles. This rule will also cover those areas in which dnata
            catering UK Ltd operates but which is customer owned and operated.
            Failure to comply with the above will result in Disciplinary action
            being taken.
          </p>
        </div>
      ),
    },
    name: {
      key: "name",
      title: "Name",
      value: getVal("name"),
      disabled: true,
    },
    signature: {
      key: "signature",
      title: "Signature",
      value: getVal("signature"),
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);

  const redirectBack = () => {
    history.push("/profile/edit/dnata-onboarding");
  };

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    submitForm(typeCode, {
      ...fieldValuesPayload,
    });
    redirectBack();
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Notice to all Staff and Management"}
          helper={""}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"dnata"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

NoticeForm.propTypes = {
  appData: any,
  submitForm: func,
};

const mapDispatchToProps = {
  submitForm: submitDnataExtraForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(NoticeForm);
